export function compareTimePast(eventDate) {
  return new Date() > new Date(eventDate); // true if time1 is later
}

export function compareTimeUpcoming(eventDate) {
  return new Date() < new Date(eventDate); // true if time1 is later
}